import { lazy, Suspense, Component } from "react";
import { Helmet } from "react-helmet-async";

const OurServices = lazy(() => import("./services"));
const ContactForm = lazy(() => import("./ContactForm"));
const AddressDetails = lazy(() => import("./AddressDetails"));
const OurLocation = lazy(() => import("./OurLocation"));
// const OurHealthcareEducation = lazy(() => import("./OurHealthcareEducation"));



const SectionLoader = () => (
  <div className="w-full py-20 flex items-center justify-center">
    <div className="h-10 w-10 border-4 border-[#FFE5D0] border-t-[#FF7A00] rounded-full animate-spin" />
  </div>
);



class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ContactPage Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full py-20 text-center">
          <h2 className="text-xl font-semibold text-red-500 mb-2">
            Something went wrong
          </h2>
          <p className="text-gray-500">
            Please refresh the page or try again later.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}



const ContactPageSplit = () => {
  return (
    <>
      <Helmet>
        <title>
          Contact Wingloe | Enterprise LIMS & Healthcare Technology Support
        </title>

        <meta
          name="description"
          content="Get in touch with Winglo, a Chennai-based enterprise healthcare technology company specializing in Laboratory Information Management Systems (LIMS) and scalable healthcare software solutions."
        />

        <meta
          name="keywords"
          content="Contact Winglo, Winglo Chennai office, healthcare software support, LIMS provider contact India, laboratory software company Chennai"
        />
      </Helmet>

      <div className="w-full overflow-hidden">
        <ErrorBoundary>
          <Suspense fallback={<SectionLoader />}>
            <OurServices />
            <ContactForm />
            <AddressDetails />
            <OurLocation />
            {/* <OurHealthcareEducation /> */}
          </Suspense>
        </ErrorBoundary>
      </div>
    </>
  );
};

ContactPageSplit.displayName = "ContactPageSplit";

export default ContactPageSplit;
